import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MaintenanceBanner = ({ bannerData, setBannerData }) => {

    return (
        <>
            <Alert
                severity="warning"
                icon={false}
                sx={{ margin: "10px 20px", alignItems: "center", color: "red" }}
                action={
                    <IconButton
                        color="inherit"
                        size="small"
                        onClick={() => setBannerData("")}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                📢 {bannerData}
            </Alert> 
        </>
    );
};

export default MaintenanceBanner;
